import { render } from "./DoctorsPage.vue?vue&type=template&id=516e157a&scoped=true&ts=true"
import script from "./DoctorsPage.vue?vue&type=script&lang=ts"
export * from "./DoctorsPage.vue?vue&type=script&lang=ts"

import "./DoctorsPage.vue?vue&type=style&index=0&id=516e157a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516e157a"]])

export default __exports__